export interface WatchListStocks {
  url?: string;
  companyName?: string;
  symbol: string;
}

export interface WatchListSortedStocks {
  change: number;
  changePercent: number;
  currentPrice: number;
  companyName: string,
  symbol: string,
  url?: string;
}

export enum WatchListHeaderEnum {
  COLUMN_LAST_PRICE = 2,
  COLUMN_CHANGE,
  COLUMN_PERCENT_CHANGE,
}
